/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-26",
    versionChannel: "nightly",
    buildDate: "2023-10-26T00:21:16.921Z",
    commitHash: "27831d78810de2db5214c298b0eb46c7cc3c6299",
};
